module.exports = __webpack_public_path__ + "79f8bf8c1a68481e09267f5215ef80ca.svg";